import { Link, useNavigate, useLocation } from "react-router-dom";
import { ShoppingBag, ShieldCheck } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function Header({ verified }) {
  const { count, setIsOpen } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  const goTo = (id) => (e) => {
    e.preventDefault();
    const scroll = () => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    };
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(scroll, 120);
    } else {
      scroll();
    }
  };

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 glass"
    >
      <div className="px-4 sm:px-8 lg:px-16 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="font-display font-black text-lg tracking-[0.2em] uppercase"
        >
          Aetheria<span className="text-magma">.</span>
        </Link>
        <nav className="hidden md:flex items-center gap-10 font-mono-tech text-xs uppercase tracking-[0.25em] text-slate-400">
          <a href="#catalog" data-testid="nav-catalog-link" onClick={goTo("catalog")} className="hover:text-cyber transition-colors duration-300">
            Collection
          </a>
          <a href="#tech" data-testid="nav-tech-link" onClick={goTo("tech")} className="hover:text-cyber transition-colors duration-300">
            Tech
          </a>
          <a href="#manifesto" data-testid="nav-manifesto-link" onClick={goTo("manifesto")} className="hover:text-cyber transition-colors duration-300">
            Manifesto
          </a>
        </nav>
        <div className="flex items-center gap-5">
          {verified && (
            <span
              data-testid="age-verified-badge"
              className="hidden sm:inline-flex items-center gap-1.5 font-mono-tech text-[10px] uppercase tracking-[0.2em] text-cyber border border-cyber/30 px-3 py-1.5"
            >
              <ShieldCheck size={12} />
              18+ Verified
            </span>
          )}
          <button
            data-testid="nav-cart-trigger"
            onClick={() => setIsOpen(true)}
            className="relative inline-flex items-center gap-2 border border-white/15 px-4 py-2 font-mono-tech text-xs uppercase tracking-[0.2em] hover:border-magma hover:text-magma transition-colors duration-300"
          >
            <ShoppingBag size={15} />
            <span className="hidden sm:inline">Cart</span>
            {count > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -top-2 -right-2 bg-magma text-white text-[10px] font-bold w-5 h-5 flex items-center justify-center rounded-full glow-magenta"
              >
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
